import { render, staticRenderFns } from "./OurCompanyFilesUploader.vue?vue&type=template&id=745af680&scoped=true&"
import script from "./OurCompanyFilesUploader.vue?vue&type=script&lang=js&"
export * from "./OurCompanyFilesUploader.vue?vue&type=script&lang=js&"
import style0 from "./OurCompanyFilesUploader.vue?vue&type=style&index=0&id=745af680&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745af680",
  null
  
)

export default component.exports